import { z } from 'zod'
import { paginacaoSchema } from './comum'

/**
 * A aba Avisos, na Configuração (ADR 0035): o que precisa de atenção na
 * manutenção do CRM. Proprietário e quem gerencia usuários veem.
 */

export const ASSUNTOS_DO_AVISO = ['pecas', 'conexao', 'arquivos', 'envios'] as const
export type AssuntoDoAvisoDto = (typeof ASSUNTOS_DO_AVISO)[number]

export const ROTULO_ASSUNTO_DO_AVISO: Record<AssuntoDoAvisoDto, string> = {
  pecas: 'Peças do CRM',
  conexao: 'Conexão do WhatsApp',
  arquivos: 'Arquivos do CRM',
  envios: 'Envios que falharam',
}

export interface AvisoDoSistemaDto {
  id: string
  assunto: AssuntoDoAvisoDto
  gravidade: 'critico' | 'atencao'
  titulo: string
  detalhe: string | null
  comoResolver: string | null
  entidade: string | null
  entidadeId: string | null
  ocorrencias: number
  primeiraEm: string
  ultimaEm: string
  resolvidoEm: string | null
  resolvidoPorNome: string | null
}

export interface RespostaAvisosDoSistema {
  /** Quantos estão abertos, para o ponto na aba e o número no seletor. */
  abertos: number
  total: number
  itens: AvisoDoSistemaDto[]
}

export const filtroAvisosDoSistemaSchema = paginacaoSchema.extend({
  situacao: z.enum(['abertos', 'resolvidos']).default('abertos'),
})
export type FiltroAvisosDoSistema = z.infer<typeof filtroAvisosDoSistemaSchema>

/**
 * Quando a pasta de arquivos do CRM vira aviso (ADR 0073).
 *
 * Os arquivos das conversas são o que cresce: a estimativa do projeto é de
 * 15 a 100 GB por ano. Quando a pasta fica sem espaço para crescer, arquivo
 * novo não é gravado, e o sintoma aparece longe da causa ("a foto do cliente
 * não abre"). O aviso sai com folga, bem antes disso.
 *
 * Conta só o espaço que sobra para a pasta. Até a ADR 0073 contava também
 * 10% do disco, o que media o computador, e não o CRM: num disco de 1 TB,
 * 90 GB livres davam aviso com o CRM ocupando poucos GB.
 */
/** Abaixo disso vira aviso: o que cabe de uns bons meses de arquivos. */
export const LIVRE_MINIMO_GB = 20

const GB = 1024 ** 3

/** `livre`: os bytes que a pasta de arquivos ainda tem para crescer. */
export function pastaApertada(livre: number): boolean {
  // Leitura estranha (negativa, NaN) não vira aviso falso.
  if (!Number.isFinite(livre) || livre < 0) return false
  return livre < LIVRE_MINIMO_GB * GB
}
